import React, { useContext, useEffect, useState } from "react";
import { QuestionContext } from "../../context/McqContext";
import { Loader } from "../../constance";
import axios from "axios";
import MostView from "./MostView";
import { GrFormNextLink, GrFormPreviousLink } from "react-icons/gr";

const Test = () => {
  const [loading, setLoading] = useState(false);
  const [mostView, setMostView] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(
    0
    // parseInt(localStorage.getItem("currentIndex")) || 0
  );
  const { questions, getQuestions } = useContext(QuestionContext);

  useEffect(() => {
    setLoading(true);
    getQuestions();
    setLoading(false);
  }, []);

  const [selectedOptions, setSelectedOptions] = useState(
    // JSON.parse(localStorage.getItem("selectedOptions")) ||
    Array(questions.length).fill([[]])
  );




  //   useEffect(() => {
  //     // localStorage.setItem("currentIndex", currentIndex);
  //     // localStorage.setItem("selectedOptions", JSON.stringify(selectedOptions));
  //   }, [currentIndex, selectedOptions]);

  // useEffect(() => {
  // const storedSelectedOptions = JSON.parse(
  //   localStorage.getItem("selectedOptions")
  // );
  //   if (storedSelectedOptions) {
  //     setSelectedOptions(storedSelectedOptions);
  //   }
  // }, []);

  const handleNextClick = () => {
    setCurrentIndex(currentIndex + 1);
  };
  const handlePreClick = () => {
    setCurrentIndex(currentIndex - 1);
  };

  const handleOptionSelect = (option, currentIndex) => {
    if (questions[currentIndex]?.type === "single") {
      setSelectedOptions((prevSelectedOptions) => {
        if (Array.isArray(prevSelectedOptions)) {
          return [
            ...prevSelectedOptions.slice(0, currentIndex),
            [option],
            ...prevSelectedOptions.slice(currentIndex + 1),
          ];
        } else {
          return {
            ...prevSelectedOptions,
            [currentIndex]: [option],
          };
        }
      });
    } else {
      setSelectedOptions((prevSelectedOptions) => {
        const existingOptions = prevSelectedOptions[currentIndex] || [];
        if (existingOptions.includes(option)) {
          return {
            ...prevSelectedOptions,
            [currentIndex]: existingOptions.filter((o) => o !== option),
          };
        } else {
          return {
            ...prevSelectedOptions,
            [currentIndex]: [...existingOptions, option],
          };
        }
      });
    }
  };

  const handleSubmit = () => {
    setLoading(true);
    const idCounts = {};
    // Object.values(selectedOptions).forEach((ids) => {
    //   ids.forEach((id) => {
    //     const trimmedId = id.slice(0, -1);
    //     if (trimmedId !== "") {
    //       idCounts[trimmedId] = (idCounts[trimmedId] || 0) + 1;
    //     }
    //   });
    // });
    Object.values(selectedOptions).forEach((ids) => {
      ids.forEach((id) => {
        // Extract the stringified array and the index
        const lastCharIndex = id.lastIndexOf(']');
        const arrayPart = id.slice(0, lastCharIndex + 1); // Extract the array part
        const indexPart = id.slice(lastCharIndex + 1); // Extract the index part

        try {
          const parsedIds = JSON.parse(arrayPart); // Parse the stringified array
          parsedIds.forEach((parsedId) => {
            if (parsedId !== "") {
              idCounts[parsedId] = (idCounts[parsedId] || 0) + 1;
            }
          });
        } catch (error) {
          console.error("Error parsing JSON:", error);
        }
      });
    });

    const sortedIdCounts = Object.entries(idCounts)
      .sort((a, b) => {
        if (b[1] !== a[1]) {
          return b[1] - a[1];
        } else {
          return (
            Object.keys(idCounts).indexOf(a[0]) -
            Object.keys(idCounts).indexOf(b[0])
          );
        }
      })
      .reduce((acc, [id, count]) => ({ ...acc, [id]: count }), {});

    const idArray = [];

    for (const id in sortedIdCounts) {
      if (Object.hasOwnProperty.call(sortedIdCounts, id) && id !== "") {
        idArray.push(id);
        if (idArray.length === 3) {
          break;
        }
      }
    }
    const promises = idArray.map((id) => axios.get(`/products/${id}`));
    Promise.all(promises)
      .then((responses) => {
        const mostViewedProducts = responses.map((response) => response.data);
        setMostView(mostViewedProducts);

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });

  };


  return (

    <div className="container mx-auto mt-36 min-h-screen">
      <h2 className="text-primary text-2xl text-center font-semibold my-10">
        Test
      </h2>

      {loading && <Loader loading={loading} />}
      {!loading && questions?.length === 0 && (
        <div className="text-xl text-center text-primary font-semibold my-10">
          No Question Found !
        </div>
      )}

      {!loading && mostView?.length == 0 && questions?.length >= 0 && (
        <div className="mx-auto md:w-[40vw]">
          {questions?.length > 0 && (
            <>
              <h3 className="text-xl ">
                Question {currentIndex + 1} of {questions?.length}:
              </h3>
              <div className="text-lg mt-5 text-primary ">
                {currentIndex + 1}. {questions[currentIndex]?.question}
              </div>

              <div className="flex flex-col mt-4  gap-2">
                {questions[currentIndex]?.options?.map((x, i) => (
                  <div className={`flex items-center mb-4 gap-3`} key={i}>
                    <div className="flex flex-row gap-2 items-center justify-start">
                      {questions[currentIndex]?.type !== "single" && (
                        <input
                          id="default-radio-1"
                          type="checkbox"
                          className="w-4 h-4"
                          checked={
                            Array.isArray(selectedOptions[currentIndex]) &&
                            selectedOptions[currentIndex].includes(
                              `${JSON.stringify(x?.productIds)}${i}`
                            )
                          }
                          onChange={() => {
                            handleOptionSelect(
                              `${JSON.stringify(x?.productIds)}${i}`,
                              currentIndex
                            );
                          }}
                        />
                      )}
                      {questions[currentIndex]?.type === "single" && (
                        <input
                          id="default-radio-1"
                          type="radio"
                          className="w-5 h-5"
                          checked={
                            Array.isArray(selectedOptions[currentIndex]) &&
                            selectedOptions[currentIndex].includes(
                              `${JSON.stringify(x?.productIds)}${i}`
                            )
                          }
                          onChange={() => {
                            handleOptionSelect(
                              `${JSON.stringify(x?.productIds)}${i}`,
                              currentIndex
                            );
                          }}
                        />
                      )}
                    </div>
                    <div
                      className={`text-sm border border-primary rounded-md w-[200px] py-1.5 px-2 ${Array.isArray(selectedOptions[currentIndex]) &&
                        selectedOptions[currentIndex].includes(
                          `${JSON.stringify(x?.productIds)}${i}`
                        )
                        ? "bg-primary text-white"
                        : ""
                        }`}
                      onChange={() => {
                        handleOptionSelect(
                          `${JSON.stringify(x?.productIds)}${i}`,
                          currentIndex
                        );
                      }}

                    >
                      <p>{x?.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          <div className="flex flex-row justify-between  items-center my-10 ">
            <button
              className="bg-primary pl-2 hover:bg-[#91C051] pr-4 flex  items-center py-2 float-end  disabled:bg-[rgb(120,150,211)] disabled:cursor-not-allowed text-white rounded-lg "
              onClick={handlePreClick}
              disabled={currentIndex === 0}
            >
              <GrFormPreviousLink className="text-2xl" />
              Previous
            </button>
            <button
              className={`bg-primary hover:bg-[#91C051] ${!(currentIndex >= questions.length - 1) ? "pl-4 pr-2" : "px-6"
                } flex gap- items-center  disabled:bg-[rgb(120,150,211)] disabled:cursor-not-allowed py-2 float-end text-white rounded-lg `}
              onClick={
                currentIndex >= questions.length - 1
                  ? handleSubmit
                  : handleNextClick
              }
              disabled={questions?.length === 0}
            >
              {currentIndex >= questions.length - 1 ? "Submit" : "Next"}
              {!(currentIndex >= questions.length - 1) && (
                <GrFormNextLink className="text-2xl" />
              )}
            </button>
          </div>
        </div>
      )}
      {mostView.length > 0 && <MostView item={mostView} />}
    </div>

  );
};

export default Test;
